import { UnauthorizedUser, UserInterface } from 'shared/types/user-interface'

export function isAuthorized(user: UserInterface | UnauthorizedUser): user is UserInterface {
  return (user as UserInterface).id !== undefined
}
